import React, { Component } from 'react';
import { Row } from 'reactstrap';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ViewCard from '../../../../Components-2025/QuestionBank/ViewCard';
import NotesIcon from '../../../../assets/img/notes/notes_icon4.svg';
import ComponentHeader from '../../../../common/ComponentHeader';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import config from '../../../config/AppRoutes';
import {
  chapterIdKey,
  isAttemptedKey,
  questionIdKey,
  descriptionKey,
  readingIdKay,
  readingNameKey,
} from './ApiAttributesKeys';
import apiServiceProvider from './ApiService';
import { showInformation } from '../../../../common/toast';

/* eslint-disable*/

export default class NotesList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      questionStatsTableName: '',
      isLoading: true,
      isUserSubscribed: false,
      pdfAlert: false,
    };
  }
  //* ===========================> {{ COMPONENT DID MOUNT START HERE }} <=====================================
  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const {
      location: { state },
    } = this.props;
    if (state && state.listData && state.listData.length) {
      const { listData } = state;
      this.setState({ listData });
    } else {
      const { readingId, chapterId } = this.props.params;
      const response = await apiServiceProvider['fetchNotes']({ readingId, chapterId });
      if (response.success) {
        const { notes, selectedExamSubscriptionDetails = {}, reading } = response;
        const { level1SubscriptionDetails = {} } = selectedExamSubscriptionDetails;
        const isSubscribed = level1SubscriptionDetails && level1SubscriptionDetails.noteStatus;
        const isLevel1Chapter = parseInt(chapterId, 10) === 1;

        if (isSubscribed || isLevel1Chapter) {
          this.setState({
            listData: notes,
            readingName: reading && reading.readingName,
            isUserSubscribed: Boolean(
              Object.keys(selectedExamSubscriptionDetails).length > 0 && isSubscribed,
            ),
          });
        } else {
          const { router } = this.context;
          router.push({ pathname: nextAwareRoute(config.CFA1_2025_NOTES) });
          showInformation(messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER);
        }
      }
    }
    this.setState({ isLoading: false });
  };
  //* ===========================> {{ COMPONENT DID MOUNT ENDED HERE }} <=====================================

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };

  redirectToNotes = async data => {
    const { listData, isUserSubscribed } = this.state;
    const { router } = this.context;
    router.push({
      pathname: nextAwareRoute(config.CFA1_2025_NOTES_VIEW).replace(':readingId', data[readingIdKay])
        .replace(':notesId', data[questionIdKey])
        .replace(':chapterId', data[chapterIdKey]),
      state: { questionData: listData, isUserSubscribed },
    });
  };
  render() {
    const { listData, isLoading, isUserSubscribed, openPremiumPopup, pdfAlert, readingName } =
      this.state;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={readingName}>
          <div>
            <CustomButton
              onClick={() =>
                router.push({
                  pathname: nextAwareRoute(config.CFA1_2025_NOTES_READING_LIST).replace(
                    ':chapterId',
                    listData.length && listData[0][chapterIdKey],
                  ),
                })
              }
            >
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}=========================================== */}

        {/* //* ================={{ QUESTION CARD WITH COUNTS START HERE }}====================================*/}
        <LoaderWrapper isLoading={isLoading}>
          <Row>
            {listData.length > 0 ? (
              listData.map(item => (
                // the note title is the admin "Name" field as-is (no auto-generated "LOS N" prefix)
                <ViewCard
                  headerIcon={NotesIcon}
                  headerContent={`${
                    item[readingNameKey].length > 50
                      ? item[readingNameKey].slice(0, 70)
                      : item[readingNameKey]
                  } (N. ${item[questionIdKey]})`}
                  bodyContent={item[descriptionKey]}
                  key={item.id}
                  onClick={() => this.redirectToNotes(item)}
                >
                  {item[isAttemptedKey] ? (
                    <div id='answered_status'>{messages.READ}</div>
                  ) : (
                    <div id='notanswered_status'>{messages.UNREAD}</div>
                  )}
                </ViewCard>
              ))
            ) : (
              <h1>No Data Found</h1>
            )}

            {!isUserSubscribed && (
              <ViewCard
                headerIcon={NotesIcon}
                headerContent={messages.SUBSCRIBE_PRACTICE_QUESTION.replace(
                  'numberOfQuestion',
                  '2,000',
                )}
                bodyContent={messages.CFA1_2025_PREMIUM_POPUP}
                paddingBox={'padding_box_free'}
              >
                <CustomButton
                  className='text-center d-block mx-auto'
                  onClick={() => router.push({ pathname: config.SUBSCRIBE })}
                >
                  Subscribe
                </CustomButton>
              </ViewCard>
            )}
          </Row>
        </LoaderWrapper>
        {/* //* ================={{ QUESTION CARD WITH COUNTS START HERE }}====================================*/}

        {/* //* ============================{{ PREMIUM MODAL START HERE }}========================================== */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={messages.CFA1_2025_PREMIUM_POPUP}
          exam={'cfa'}
        />
        {/* //* ============================{{ PREMIUM MODAL ENDED HERE }}========================================== */}

        {/* //* ============================{{ PDF MODAL START HERE }}========================================== */}
        <PDFModelComponent
          type={'Question'}
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={pdfAlert}
          PDFContentMessage={messages.PDF_DOWNLOAD_CONTENT_MESSAGE}
        />
        {/* //* ============================{{ PDF MODAL ENDED HERE }}========================================== */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ViewNotesList/NotesList.jsx